import Service from "../../../Services/index";

const dashboard = {
    namespaced: true,
    state: {
        sale_by_seller: [],
        sale_by_product: [],
        search:{
            start_date: null,
            end_date: null,
        },
        sale_search:[],
        sale_by_seller_all: [],
        sale_by_seller_all_search: [],
        sale_by_seller_data_search:{
            start_date: null,
            end_date: null,
            sellers_name: [],
            flag_search: false,
            topics: []
        },
        product:[],
        search_product:{
            start_date: null,
            end_date: null,
            sellers_name: [],
            products_type: "",
            product_type_id: "",
        },
        //TODO: JANE
        customer_by_product : [],
        dataPaginateCustomer : {
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        compare_product_list:[],
        dataPaginateCompare : {
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        invoice_sale : [],
        dataPaginateInvoiceSale : {
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        },
        formRecordMessage : {
            id : '',
            message : '',
        }
    },
    mutations: {
        GET_SALE_SELLER:(state,data)=>{
            state.sale_by_seller = data;
        },
        GET_SALE_PRODUCT:(state,data)=>{
            state.sale_by_product = data;
        },
        GET_PRODUCT:(state,data)=>{
            state.product = data;
        },
        GET_SALE_SEARCH:(state,data)=>{
            state.sale_search = data;
        },
        GET_SALE_SELLER_ALL:(state,data)=>{
            state.sale_by_seller_all = data;
        },
        CLEAR_SEARCH :(state)=> {
            state.sale_by_seller_data_search = {
                start_date: null,
                end_date: null,
                sellers_name: [],
                flag_search: false,
                topics: []
            };
            state.search = {
                start_date: null,
                end_date: null,
            };
            state.search_product = {
                start_date: null,
                end_date: null,
                sellers_name: [],
                // products: [],
                products_type: [],
            }
        },

        //TODO: JANE
        GET_CUSTOMER_BY_PRODUCT:(state,res)=>{
            state.customer_by_product = res.data;
            state.dataPaginateCustomer = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        },
        GET_COMPARE_COMPARE:(state,res)=>{
            state.compare_product_list = res.data;
            state.dataPaginateCompare = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        },
        GET_INVOICE_SALE:(state,res)=>{
            state.invoice_sale = res.data;
            state.dataPaginateInvoiceSale = {
                current_page :res.current_page,
                from : res.from,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        },
        CLEAR_FORM_RECORD_MESSAGE : (state)=>{
            state.formRecordMessage = {
                id : '',
                message : '',
            }
        },
        SET_FORM_RECORD_MESSAGE : (state,res)=>{
            state.formRecordMessage = res;
        }
    },
    actions: {
        getSaleGroupBySeller({ commit }) {
            return Service.Dashboard
                .getSaleGroupBySeller()
                .then(response => {
                    commit("GET_SALE_SELLER", response);
                })
        },
        getSaleGroupByProduct({ commit }) {
            return Service.Dashboard
                .getSaleGroupByProduct()
                .then(response => {
                    commit("GET_SALE_PRODUCT", response);
                })
        },
        getSaleByProduct({ commit },data) {
            return Service.Dashboard.getSaleByProduct(data)

        },
        search({commit},data){
            return Service.Dashboard.searchSale(data).then(res=>{
                commit("GET_SALE_SEARCH",res)
            })
        },
        getSaleGroupBySellerAll({ commit }) {
            return Service.Dashboard.getSaleGroupBySellerAll();
        },
        SaleGroupBySellerAllSearch({commit},data){
            console.log('module');
            return Service.Dashboard.searchSaleGroupBySellerAll(data);
        },
        saleByProductSearch({commit},data){
            return Service.Dashboard.searchSaleByProduct(data);
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },

        //TODO: JANE
        getReportCustomerByProduct({commit},data){
            return Service.Dashboard.getReportCustomerByProduct(data);
        },
        getReportCompareProduct({commit},{page=1,data}){
            return Service.Dashboard.getReportCompareProduct(page,data);
        },
        getReportInvoiceSale({commit},{page=1,data}){
            console.log(data);
            return Service.Dashboard.getReportInvoiceSale(page,data);
        },
        //ใบบันทึกข้อความ
        getUpdateLogData({commit},{page,data}) {
            return Service.Dashboard.getUpdateLogData(page,data);
        },
        saveUpdateLogData({commit},data){
            return Service.Dashboard.saveUpdateLogData(data);
        },
        printUpdateLogData({commit},data){
            return Service.Dashboard.printUpdateLogData(data);
        },
        recordMessage({commit},{page = 1}){
            return Service.Dashboard.getRecordMessage(page);
        },
        saveRecordMessage({commit},{id,data}){
            if(!id){ //create
                return Service.Dashboard.createRecordMessage(data);
            }else{ //update
                return Service.Dashboard.updateRecordMessage(id,data);
            }
        },
        showRecordMessage({commit},id){
            return Service.Dashboard.showRecordMessage(id).then(res=>{
                commit('SET_FORM_RECORD_MESSAGE',res);
            });
        },
        deleteRecordMessage({commit},id){
            return Service.Dashboard.deleteRecordMessage(id);
        },
        clearFormRecordMessage({commit}){
            commit('CLEAR_FORM_RECORD_MESSAGE');
        }
    }
};

export default dashboard;
